import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from 'src/services/api/api.service';
import { environment } from 'src/environment/environment';
import { SUMMARY_ENGINE_ROUTE } from 'src/app/summary/summary-engine.registry';

// Runs before Summary Type 1's own route guards. If this portal is configured
// for a different summary engine (e.g. 'v2'), redirects there instead and
// blocks the Type 1 route from activating. Type 1 renders unchanged when the
// portal's engine is the default ('v1') or unset.
export const SummaryTypeRedirectGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const service = inject(ApiService);
  const router = inject(Router);
  const portalId = environment.portalId;

  return service.getParamRequest('get-summary-engine', { portalId }).pipe(
    map((response: any) => {
      const summaryEngine = response?.data?.summaryEngine || 'v1';
      const targetRoute = SUMMARY_ENGINE_ROUTE[summaryEngine];
      if (targetRoute && targetRoute !== SUMMARY_ENGINE_ROUTE['v1']) {
        return router.parseUrl(targetRoute);
      }
      return true;
    }),
    catchError(() => of(true))
  );
};
